// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"504":"chunk-vendors","524":"app"}[chunkId] + "." + {"504":"3462a6f5","524":"ef8fb435"}[chunkId] + ".css";
};